var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "pm-template" }, [
      _c(
        "div",
        { staticClass: "pm-template-form box-bubble" },
        [
          _c(_setup.PreventiveMaintenanceTemplateForm, {
            attrs: { "edit-id": _setup.editId },
            on: {
              "on-cancel": _setup.onCancelHandler,
              "on-success": _setup.onSuccessHandler
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pm-template-index box-bubble" },
        [
          _c(_setup.PreventiveMaintenanceTemplateIndex, {
            ref: "pmTemplateIndexRef",
            on: { "on-edit": _setup.onEditHandler }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "pm-template-list-item" },
      [
        _setup.editId
          ? _c(_setup.PMTemplateListItem, { key: _setup.rerenderListItem })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }